import { BrowserRouter as Router, Routes, Route, useParams, Navigate, useSearchParams } from "react-router-dom";
import React from "react";

import 'react-toastify/dist/ReactToastify.css';
import "./App.module.css";
import "./styles/globalStyles.css";

import { ToastContainer } from "react-toastify";
import { ClientIdContext } from "./context/context.js";

import Home from "./pages/public/Home.js";
import Admin from "./pages/admin/Admin.js";
import Confirmation from './pages/public/Confirmation.js';
import Calendar from "./pages/admin/Calendar.js";
import BookingDetailsPage from "./pages/admin/BookingDetails.js";
import Expenses from "./pages/admin/Expenses.js";
import AdminBooking from "./pages/admin/AdminBooking.js";
import Login from "./pages/public/Login.js";
import ProtectedRoute from "./components/protectedRoute.js";
import BasePage from "./pages/public/BasePage.js";
import Bookkeeping from "./pages/admin/Bookkeeping.js";
import Dashboard from "./pages/admin/DashBoard.js";
import FormSigner from "./pages/public/FormSigner.js";


function HomeWrapper() {
  const { clientId } = useParams();
  return (
    <ClientIdContext.Provider value={clientId}>
      <Home client_id={clientId} admin={false} />
    </ClientIdContext.Provider>
  );
}

function HomeNestedRoutes() {
  const { clientId } = useParams();

  return (
    <ClientIdContext.Provider value={clientId}>
      <Confirmation />
    </ClientIdContext.Provider>
  )
}

function BookingConfirmationRedirect() {
  const { clientId } = useParams();
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();

  return <Navigate to={`/${clientId}/confirmation${query ? `?${query}` : ""}`} replace />;
}

function FormSignerWrapper() {
  const { clientId } = useParams();

  return (
    <ClientIdContext.Provider value={clientId}>
      <FormSigner />
    </ClientIdContext.Provider>
  );
}


function AdminRoutes() {
  const { clientId } = useParams();

  return (
    <ClientIdContext.Provider value={clientId}>
      <Admin />
    </ClientIdContext.Provider>
  );
}

function AdminNestedRoutes() {
  return (
    <>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="login" element={<Login />} />
      <Route
        path="bookings"
        element={
          <ProtectedRoute>
            <Calendar />
          </ProtectedRoute>
        }
      />
      <Route
        path="create-booking"
        element={
          <ProtectedRoute>
            <AdminBooking />
          </ProtectedRoute>
        }
      />
      <Route
        path="booking"
        element={
          <ProtectedRoute>
            <BookingDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="bookkeeping"
        element={
          <ProtectedRoute>
            <Bookkeeping />
          </ProtectedRoute>
        }
      />
      <Route
        path="dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="expenses"
        element={
          <ProtectedRoute>
            <Expenses />
          </ProtectedRoute>
        }
      />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<BasePage />} />
        <Route path="/:clientId" element={<HomeWrapper />} />
        <Route path="/:clientId/confirmation" element={<HomeNestedRoutes />} />
        <Route path="/:clientId/booking-confirmation" element={<BookingConfirmationRedirect />} />
        <Route path="/:clientId/marina-authorization" element={<FormSignerWrapper />} />
        <Route path="/:clientId/admin" element={<AdminRoutes />}>
          {AdminNestedRoutes()}
        </Route>
      </Routes>


      <ToastContainer position="bottom-right" autoClose={3000} />
    </Router>
  );
}

export default App;
